/**
 * Reset property's "done" flag
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 * @param {TimelineMapProps} timeline
 * @param {StepProps} step
 * @param {Boolean} [last]
 */
const resetDoneProperties = (main, trigger, timeline, step, last) => {
  const alternate = timeline.get("has-alternate");

  /**
   * If last step, remove every style
   */
  if (last && !alternate) {
    const steps = /** @type {StepsMapProps} */ (timeline?.get("steps"));

    for (const step of steps.values()) {
      const properties = /** @type {Map<String, Map<String, any>>} */ (
        step.get("properties")
      );

      for (const [name, parent] of properties) {
        for (const [property, value] of parent) {
          value.set("current-iteration", 0);
          value.set("done", false);

          const actives = main.activeProperties.get(name)?.get(property);

          if (!actives) {
            continue;
          }

          for (const active of actives[0].values()) {
            const triggerName = trigger.get("name");
            active.delete(triggerName);

            if (!active.size) {
              main.activeProperties.get(name).delete(property);
            }
          }
        }
      }
    }
  } else {
    const properties = /** @type {Map<String, Map<String, any>>} */ (
      step.get("properties")
    );

    for (const parent of properties.values()) {
      for (const property of parent.values()) {
        property.set("current-iteration", 0);
        property.set("done", false);
      }
    }
  }
};

export default resetDoneProperties;
